










import Vue from "vue";

import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

const { SHIFT_NOTIFICATION_TOAST } = VUEX_ROOT_ACTION_NAMES;

interface Methods {
  afterLeave: () => void;
}

interface Computed {
  currentNotificationToast: any;
  notificationToastText: string;
}

export default Vue.extend<any, Methods, Computed>({
  name: "NotificationToast",

  data() {
    return {
      show: false
    };
  },

  methods: {
    afterLeave() {
      this.$store.dispatch(SHIFT_NOTIFICATION_TOAST);
    }
  },

  computed: {
    currentNotificationToast() {
      return this.$store.state.notificationToasts[0];
    },

    notificationToastText() {
      return this.currentNotificationToast?.text;
    }
  },

  watch: {
    currentNotificationToast(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.show = true;

        setTimeout(() => {
          this.show = false;
        }, newValue.timespan || 3000);
      }
    }
  }
});
